import { defineStore } from 'pinia'
import { type BookingForm } from '../types/MultiStep'

export const useBookingStore = defineStore('BookingStore', () => {
  const localePath = useLocalePath()
  const data = ref<BookingForm>({
    state: {
      locked: false,
      step: 0,
      price: 0,
      bob_price: 0,
      bob_locked: false,
      delivery_fee: 0,
      drink_price: 0,
      drink_name: '',
    },
    amount: 1,
    package: undefined,
    date: '',
    start: '',
    duration: 0,
    bob_by_feestfiets: false,
    delivery_point: '',
    collection_point: '',
    drink: 0,

    client_first_name: '',
    client_last_name: '',

    client_phone_number: '',
    client_second_phone_number: '',

    client_email: '',

    client_street: '',
    client_house_number: '',
    client_postal_code: '',
    client_city: '',

    client_accepted_marketing: false,
    delivery_fee: 0,
  })

  function nextStep() {
    data.value.state.step++

    switch (data.value.state.step) {
      case 1:
        return localePath({ name: 'index-info' })

      case 2:
        return localePath({ name: 'index-location' })

      case 3:
        return localePath({ name: 'index-drink' })

      case 4:
        return localePath({ name: 'index-contact' })
      case 5:
        return localePath({ name: 'index-end' })
    }

    return
  }

  return { data, nextStep }
})
